import React from 'react';

export const CONSTANTS = {
  ZOOM_IMAGE: 'zoomImage',
  IMAGE_CONTAINER: 'zoomImageContainer',
  FIT_DIMENSIONS: {width: 686, height: 458},
  FIT_MOBILE: {width: '100%', height: 600},
  MAX_MOBILE: 767,
  MIN_ZOOM: 50,
  MAX_ZOOM: 200,
  ZOOM_VALUE_RATE: 20,
  SCROLL_RATE: 20,
  DIRECTION: {LEFT: 'LEFT', RIGHT: 'RIGHT', UP: 'UP', DOWN: 'DOWN'},
};

export const EVENTS = {
  IMAGE_LOADED: 'IMAGE_LOADED',
  UPDATE_ZOOM_SCALE: 'UPDATE_ZOOM_SCALE',
};

const INITIAL_STATE = {
  actualImageSize: {width: 0, height: 0},
  currentImageSize: {width: 10, height: 10},
  zoomValue: 0,
  zoomDropdownOptions: [
    {value: 0, label: 'Fit'},
    {value: 200, label: '200%'},
    {value: 150, label: '150%'},
    {value: 100, label: '100%'},
    {value: 75, label: '75%'},
    {value: 50, label: '50%'},
  ],
};

function zoomImageReducer(state, action) {
  switch (action.type) {
    case EVENTS.IMAGE_LOADED:
      return onImageLoadedEvent(state, action.payload);
    case EVENTS.UPDATE_ZOOM_SCALE:
      return onUpdateZoomScaleEvent(state, action.payload);
    default:
      return {...state};
  }
}

let zoomImage, zoomImageContainer;
export function useZoomImageHook() {
  const [state, dispatch] = React.useReducer(zoomImageReducer, INITIAL_STATE);

  function onImageLoaded() {
    zoomImage = document.querySelector(`#${CONSTANTS.ZOOM_IMAGE}`);
    zoomImageContainer = document.querySelector(
      `#${CONSTANTS.IMAGE_CONTAINER}`
    );
    const {naturalWidth, naturalHeight} = zoomImage;
    dispatch({
      type: EVENTS.IMAGE_LOADED,
      payload: {
        naturalHeight,
        naturalWidth,
      },
    });
  }

  function setZoom(zoomValue) {
    if (zoomValue > CONSTANTS.MAX_ZOOM) zoomValue = CONSTANTS.MAX_ZOOM;
    if (zoomValue < CONSTANTS.MIN_ZOOM) zoomValue = CONSTANTS.MIN_ZOOM;
    dispatch({type: EVENTS.UPDATE_ZOOM_SCALE, payload: {zoomValue}});
  }

  function updateScroll(direction) {
    switch (direction) {
      case CONSTANTS.DIRECTION.UP:
        zoomImageContainer.scrollTop -= CONSTANTS.SCROLL_RATE;
        break;
      case CONSTANTS.DIRECTION.DOWN:
        zoomImageContainer.scrollTop += CONSTANTS.SCROLL_RATE;
        break;
      case CONSTANTS.DIRECTION.LEFT:
        zoomImageContainer.scrollLeft -= CONSTANTS.SCROLL_RATE;
        break;
      case CONSTANTS.DIRECTION.RIGHT:
        zoomImageContainer.scrollLeft += CONSTANTS.SCROLL_RATE;
        break;
      default:
        break;
    }
  }

  return {state, onImageLoaded, setZoom, updateScroll};
}

/* function to calculate zoomScale from zoomValue send in from react components */
function getZoomScaleFromValue(zoomValue) {
  return zoomValue / 100;
}

/* function to calcuate scaledDimension from zoomValue */
function getScaledDimension(originalDimension, scale) {
  return originalDimension * scale;
}

/* function to calculate zoomValue from original ImageWidth */
function getZoomValueFromNaturalWidth(naturalWidth) {
  const CANVAS_WIDTH = 686;
  return parseInt((CANVAS_WIDTH * 100) / naturalWidth);
}

/* function to update Fit Option's zoom value in Dropdown Options */
function updateDropdownOptions(dropdownOptions, fitZoomValue) {
  const FIT = 'Fit';
  return dropdownOptions.map((option) => {
    if (option.label === FIT) {
      return {...option, value: fitZoomValue};
    }
    return {...option};
  });
}

/* zoomImageReducer Helper functions */
function onImageLoadedEvent(state, payload) {
  const widthMobile = window.screen.width;

  const setCurrentImageSize = () => {
    if (widthMobile >= CONSTANTS.MAX_MOBILE) {
      return CONSTANTS.FIT_DIMENSIONS;
    } else return CONSTANTS.FIT_MOBILE;
  };

  let zoomValue = getZoomValueFromNaturalWidth(payload.naturalWidth);
  return {
    ...state,
    actualImageSize: {
      width: payload.naturalWidth,
      height: payload.naturalHeight,
    },
    currentImageSize: setCurrentImageSize(),
    zoomValue,
    zoomDropdownOptions: updateDropdownOptions(
      state.zoomDropdownOptions,
      zoomValue
    ),
  };
}

function onUpdateZoomScaleEvent(state, payload) {
  let zoomScale = getZoomScaleFromValue(payload.zoomValue);
  return {
    ...state,
    currentImageSize: {
      width: getScaledDimension(state.actualImageSize.width, zoomScale),
      height: getScaledDimension(state.actualImageSize.height, zoomScale),
    },
    zoomValue: payload.zoomValue,
  };
}
